export default __webpack_public_path__ + "static/PNG-CHAIZER-Letter-ea02ff9603e98a2f02b6b074d37a7ec9.png";